/**
 * Provides styled components for lists.
 */
import { TextInput, View, ViewStyle } from 'react-native';
import styled from 'styled-components/native';

import { Colors } from 'theme/colors';
import { FontFamily, FontSize } from 'theme/fonts';

// 20 PUSHES UP ADDRESS
export const SearchContainer = styled(View)<ViewStyle>`
  background-color: ${Colors.white};
  left: 0;
  right: 0;
  bottom: ${props => props.bottom || 0};
`;

export const SearchInputContainer = styled(View)`
  background-color: ${Colors.grey};
  padding-horizontal: 5;
  padding-vertical: 5;
  flex-direction: row;
`;

export const SearchInput = styled(TextInput)`
  flex: 1;
  font-family: ${FontFamily.Light};
  font-size: ${FontSize.Regular};
  height: 45;
  border-radius: 5;
  background-color: ${Colors.white};
  padding-horizontal: 15;
  color: ${Colors.black};
`;

export const SearchInputLoader = styled(View)`
  width: 60;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.white};
`;
